module.exports = __webpack_public_path__ + "img/211756c.png";